import _slicedToArray from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim/index.js';
import { notifyManager } from "../core/index.mjs";
import { parseFilterArgs } from "../core/utils.mjs";
import { useQueryClient } from "./QueryClientProvider.mjs";
export function useIsFetching(arg1, arg2, arg3) {
  var _parseFilterArgs = parseFilterArgs(arg1, arg2, arg3),
      _parseFilterArgs2 = _slicedToArray(_parseFilterArgs, 2),
      filters = _parseFilterArgs2[0],
      _parseFilterArgs2$ = _parseFilterArgs2[1],
      options = _parseFilterArgs2$ === void 0 ? {} : _parseFilterArgs2$;

  var queryClient = useQueryClient({
    context: options.context
  });
  var queryCache = queryClient.getQueryCache();
  return useSyncExternalStore(React.useCallback(function (onStoreChange) {
    return queryCache.subscribe(notifyManager.batchCalls(onStoreChange));
  }, [queryCache]), function () {
    return queryClient.isFetching(filters);
  }, function () {
    return queryClient.isFetching(filters);
  });
}